import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import LoadingPopup from "./loading";
import { secretKey } from "./data";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import LeadDetail from "./leadDetail";
import SendClientsConf from "./sendClientsConf";
import SendLeadsDetails from "./sendLeadsDetails";
import ImportLeadSend from "./importLeadsSend";
import SendClientsResults from "./sendClientsResults";
import { downloadExcel } from "react-export-table-to-excel";
import ClickReport from "./clickReport";

const MySwal = withReactContent(Swal2);

const Reports = (props) => {
  const [loading, setLoading] = useState(false);
  const [showClickReport, setShowClickReport] = useState(false);

  return (
    <div>
      {loading ? (
        <LoadingPopup />
      ) : (
        <>
          <div
            style={{
              backgroundColor: "white",
              top: "0",
              paddingTop: "2vh",
              paddingBottom: "0vh",
              paddingLeft: "2vw",
              paddingRight: "2vw",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "left",
                gap: "1vw",
              }}
            >
              <button
                className="loginButtonLogin"
                value="yes"
                style={{
                  margin: "0",
                  backgroundColor: "blue",
                  borderColor: "blue",
                  width: "180px",
                }}
                onClick={() => {
                  setShowClickReport(true);
                }}
              >
                RAPORT PRACY
              </button>
            </div>
          </div>
          <div
            style={{
              paddingTop: "2vh",
              paddingBottom: "0vh",
              paddingLeft: "2vw",
              paddingRight: "2vw",
            }}
          >
            {showClickReport ? <ClickReport /> : ""}
          </div>
        </>
      )}
    </div>
  );
};

export default Reports;
